import { useEffect, useState } from "react";
import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf";
import { buildPageIndex } from "@/lib/pdfSearch";

pdfjsLib.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL || ""}/pdf.worker.min.js`;

// Loads the PDF, page sizes, and per-page text index + text items (for highlight geometry).
export function usePdfDocument(blob) {
  const [state, setState] = useState({ pdf: null, pages: [], indexes: [], indexing: false, error: null });

  useEffect(() => {
    if (!blob) return;
    let cancelled = false; let doc = null;
    (async () => {
      try {
        doc = await pdfjsLib.getDocument({ data: await blob.arrayBuffer() }).promise;
        if (cancelled) return;
        const pages = [];
        for (let i = 1; i <= doc.numPages; i++) {
          const vp = (await doc.getPage(i)).getViewport({ scale: 1 });
          pages.push({ w: vp.width, h: vp.height, transform: vp.transform, items: [] });
        }
        if (cancelled) return;
        setState({ pdf: doc, pages, indexes: [], indexing: true, error: null });
        const indexes = [];
        for (let i = 1; i <= doc.numPages; i++) {
          const tc = await (await doc.getPage(i)).getTextContent();
          if (cancelled) return;
          pages[i - 1].items = tc.items.filter((it) => it.str !== undefined)
            .map((it) => ({ ...it, family: tc.styles[it.fontName]?.fontFamily || "sans-serif" }));
          indexes.push(buildPageIndex(pages[i - 1].items));
        }
        setState({ pdf: doc, pages: [...pages], indexes, indexing: false, error: null });
      } catch (e) {
        if (!cancelled) setState((s) => ({ ...s, indexing: false, error: e?.message || "PDF açılamadı" }));
      }
    })();
    return () => { cancelled = true; doc?.destroy(); };
  }, [blob]);

  return state;
}

let measureCanvas = null;

// Highlight rect (scale-1 CSS px) for a char range inside one text item.
export function itemRangeRect(page, { itemIdx, from, to }) {
  const it = page.items[itemIdx];
  const tx = pdfjsLib.Util.transform(page.transform, it.transform);
  const fh = Math.hypot(tx[2], tx[3]);
  const ctx = (measureCanvas ||= document.createElement("canvas")).getContext("2d");
  ctx.font = `20px ${it.family}`;
  const full = ctx.measureText(it.str).width || 1;
  const a = ctx.measureText(it.str.slice(0, from)).width / full;
  const b = ctx.measureText(it.str.slice(0, to)).width / full;
  return { x: tx[4] + it.width * a, y: tx[5] - fh, w: it.width * (b - a), h: fh * 1.15 };
}
